<!--
 * @Description: 项目执行人男性年龄分布
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="200" :itemWidth="420 + 56">
      <div
        style="height: 200px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
        @click="onChange(item.value)"
      >
        <BaseCard style="width: 420px; height: 200px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            :value="item.value"
            :model-value="curItem.value"
          >
            <div
              v-if="item.svg"
              v-html="item.svg"
              style="margin-top: 24px"
            ></div>
            <div
              v-else
              style="height: 120px; display: flex; align-items: center"
            >
              <component :is="cmpName(item.moduleType)" />
            </div>
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import PcModuleManSex from '../../../../../bi-pc-module/pc-module-age-man/index';
import { commonSVG } from '../../../commonSVG';

const CHILD_KEY = '4_2_3';
const TYPE_MAPPING: Array<{
  value: any;
  moduleType?: any;
  index: number;
  svg?: string;
}> = [
  ...[1, 2, 3, 4, 5, 6].map(i => {
    return {
      value: 'pc-module-age-distribution-' + i,
      moduleType: 'pc-module-age-man-' + i,
      index: i
    };
  }),
  {
    svg: commonSVG,
    value: [2, 3, 9, 6, 10, 7].join(','),
    index: 6
  }
];

const cmpName = name => {
  return PcModuleManSex.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
</script>
